export const WEEK_FILTER = 0
export const MONTH_FILTER = 1

// レイアウト
export const SUMMARY = "SUMMARY"
export const DETAIL = "DETAIL"
